import { useState } from "react";
import { motion } from "framer-motion";
import { StarBurst } from "../ui/StarBurst";
import type { MultipleChoiceQuestion } from "../levelTypes";

interface Props {
  question: MultipleChoiceQuestion;
  onAnswer: (result: "correct" | "wrong") => void;
}

type Phase = "idle" | "correct" | "wrong";
const LETTERS = ["A", "B", "C", "D"];

export function MultipleChoice({ question, onAnswer }: Props) {
  const [phase, setPhase] = useState<Phase>("idle");
  const [chosenIndex, setChosenIndex] = useState<number | null>(null);

  function handleChoice(index: number) {
    if (phase !== "idle") return;
    const isCorrect = index === question.correctIndex;
    setChosenIndex(index);
    setPhase(isCorrect ? "correct" : "wrong");

    setTimeout(() => {
      onAnswer(isCorrect ? "correct" : "wrong");
    }, 1500);
  }

  return (
    <div className="exercise-card">
      <StarBurst active={phase === "correct"} />

      <p className="mc__question">{question.question}</p>

      <motion.div
        className="mc__options"
        animate={
          phase === "wrong"
            ? { x: [0, -10, 10, -8, 8, -4, 4, 0] }
            : { x: 0 }
        }
        transition={{ duration: 0.4 }}
      >
        {question.options.map((opt, i) => {
          let extraClass = "";
          if (phase !== "idle") {
            if (i === question.correctIndex) extraClass = " option-btn--correct";
            else if (i === chosenIndex) extraClass = " option-btn--wrong";
          }

          return (
            <motion.button
              key={i}
              className={`option-btn${extraClass}`}
              data-opt={i}
              disabled={phase !== "idle"}
              onClick={() => handleChoice(i)}
              whileTap={phase === "idle" ? { scale: 0.98 } : {}}
            >
              <span className="option-btn__letter">{LETTERS[i]}</span>
              {opt}
            </motion.button>
          );
        })}
      </motion.div>
    </div>
  );
}
